// Lightweight toast notifications — replaces browser `alert()` for
// transient feedback (CRUD success/failure, validation errors).
//
// CLAUDE.md "Toast notifications" rule: build via JS, prepend to
// `document.body`, wired to the `flash` Stimulus controller for the
// 5-second auto-dismiss + slide-out. Reference implementation lives
// in `fee_schedule_controller.js#_showToast` (this is just that
// helper extracted so other controllers don't have to redefine it).
//
// Usage:
//   import { showToast } from "../lib/toast"
//
//   showToast("Saved")                       // success (green)
//   showToast("Failed to save", "error")     // error (red)

const ICONS = {
  notice: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>',
  alert: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/></svg>'
}

export function showToast(message, type = "success") {
  const cssType = type === "error" || type === "alert" ? "alert" : "notice"
  const el = document.createElement("div")
  el.className = `flash-toast-${cssType}`
  el.setAttribute("data-controller", "flash")
  el.setAttribute("data-flash-dismiss-after-value", "5000")
  el.setAttribute("role", "alert")

  const iconDiv = document.createElement("div")
  iconDiv.className = "shrink-0"
  iconDiv.innerHTML = ICONS[cssType]

  const msgP = document.createElement("p")
  msgP.className = "flex-1 text-sm"
  msgP.textContent = message

  el.appendChild(iconDiv)
  el.appendChild(msgP)
  document.body.prepend(el)
}
